import React from 'react';
import BubbleMessage from './BubbleMessage';
import { useTranslate } from '@tolgee/react';

const NonsupportMessage: React.FC<{}> = (props) => {
  const { t } = useTranslate();

  return (
    <BubbleMessage className="left">
      [{t('scene.chatWorkspace.messageThread.feedback.unknownMessageType')}]
    </BubbleMessage>
  );
};
export default NonsupportMessage;
